import { useState } from 'react';
import { ConfirmDialog } from '@halo/ui-chat-react';

export interface ClearChatHistoryDialogProps {
  open: boolean;
  onClose: () => void;
  onOk: (deleteChatHistory: boolean) => Promise<void>;
}

export const ClearChatHistoryDialog = ({ open, onClose, onOk }: ClearChatHistoryDialogProps) => {
  const { t } = useTranslation();
  const [deleteChatHistory, setDeleteChatHistory] = useState(true);
  return (
    <ConfirmDialog
      disabledPortal={false}
      open={open}
      onClose={() => {
        onClose();
        setDeleteChatHistory(true);
      }}
      okText={t('buttons.clear')}
      title={t('chatSettings.clearAllChatHistory')}
      subTitle={t('chatSettings.clearAllChatHistorySubTitle')}
      onOk={async () => {
        await onOk(deleteChatHistory);
        setDeleteChatHistory(true);
      }}
    />
  );
};
